import {DateSubType} from '../constants';
import {DateRuleSubTypeLabel} from '../locales';

export const getDateSubTypeLabel = (type: DateSubType) =>
	DateRuleSubTypeLabel[type];

export default getDateSubTypeLabel;
